import { useState, useEffect } from 'react';

import { OptionType } from 'components/atoms/Select';
import { getAllowanceList } from 'api/attendAllowance';

/**
 * 手当の選択ボックス用データを取得
 * 手本: useHolidayOptions
 */
export const useAllowanceOptions = (): Array<OptionType> => {
  const [allowanceOptions, setAllowanceOptions] = useState<Array<OptionType>>([]);
  useEffect(() => {
    getAllowanceList().then((allowances) => {
      setAllowanceOptions(allowances.map((allowance: { allowanceId: any; allowanceName: any; }) => ({
        value: allowance.allowanceId,
        label: allowance.allowanceName,
      })));
    }).catch(() => {
      setAllowanceOptions([]);
    });
  }, []);
  return allowanceOptions;
};

export default useAllowanceOptions;
